import React from 'react';
import PropTypes from 'prop-types';
import ActionCell from '../layout/ActionCell';
import Cell from 'components/list/Filters/layout/Cell';
import IconButton from 'material-ui/IconButton';
import LastCell from 'components/list/Filters/layout/LastCell';
import MatchTypes from 'components/list/Filters/form/components/MatchTypes';
import Row from 'components/list/Filters/layout/Row';
import RowTitle from 'components/list/Filters/layout/RowTitle';
import compose from 'recompose/compose';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { DeactivateIcon } from 'assets/materialIcons/materialIcons';
import { Field, reduxForm, submit, getFormValues, unregisterField, change, untouch } from 'redux-form';
import { MenuItem, SelectField } from 'material-ui';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

class Advanced extends React.Component {
    constructor(props) {
        super(props);

        const {
            filters,
            filterValues,
        } = props;

        // Collecting all fields and merge them together.
        let available = {};

        utils.each(filters, function (filter) {
            available = Object.assign(available, filter);
        });

        // Looping through the filterValues and adding them to the active fields.
        let active = {};

        utils.each(filterValues, function (_, filterKey) {
            active = Object.assign(active, {
                [filterKey]: available[filterKey],
            });

            delete available[filterKey];
        });

        this.state = {
            active: active,
            available: available,
        };
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPress, true);
    }

    componentDidUpdate(prevProps) {
        const {
            dispatch,
            form,
            formInstance,
        } = this.props;

        const prevFormInstance = prevProps.formInstance;

        if (prevFormInstance && formInstance) {
            const { registeredFields } = formInstance;
            const prevRegisteredFields = prevFormInstance.registeredFields;

            // Nothing was registered, the new lifecycle will add the new fields.
            if (utils.isEmpty(prevRegisteredFields)) {
                return;
            }

            /**
             * Because a "feature" in redux-form the values will always exist when the registeredfield will be removed.
             * If in the next lifecycle registeredFields not exist anymore, but the previous fields did,
             * we will loop and remove all the previous fields.
             */
            if (utils.isEmpty(registeredFields) && !utils.isEmpty(prevRegisteredFields)) {
                utils.each(prevRegisteredFields, (key) => {
                    const splittedKey = key.name.split('[');

                    dispatch(change(form, splittedKey[0], null));
                    dispatch(untouch(form, splittedKey[0]));
                });
            }
        }
    }

    componentWillUnmount() {
        const {
            dispatch,
            form,
            formValues,
        } = this.props;

        document.removeEventListener('keydown', this.handleKeyPress, true);

        // Unregister Unused fields.
        utils.each(formValues, (value, key) => {
            if (!value || !value.value) {
                dispatch(unregisterField(form, key));
            }
        });
    }

    handleKeyPress = (event) => {
        // Prevent double tapping.
        if (!event.repeat) {
            if (event.key === 'Enter') {
                this.handleSubmit();
            }
        }
    }

    handleInitializeValues = (raw) => {
        let data = {};

        utils.each(raw, function (value, key) {
            data[key] = {};

            utils.each(value, function (itemValue, itemKey) {
                data[key][itemKey] = itemValue;
            });
        });

        this.props.initialize(data);
    }

    addFilter = (property) => {
        if (!property) {
            return;
        }

        this.setState((prevState) => {
            let { active, available } = prevState;

            // Validate if the property exists in the object.
            if (!available.hasOwnProperty(property)) {
                return;
            }

            active[property] = available[property];

            delete available[property];

            return {
                active: active,
                available: available,
            };
        });
    }

    removeFilter = (property) => {
        if (!property) {
            return;
        }

        const {
            dispatch,
            form,
        } = this.props;

        this.setState((prevState) => {
            let { active, available } = prevState;

            available[property] = active[property];

            delete active[property];

            return {
                active: active,
                available: available,
            };
        }, () => {
            dispatch(unregisterField(form, property));

            if (isEmpty(this.state.active)) {
                dispatch(submit(form));
            }
        });
    }

    selectUnregisteredFieldValues = (values, fields) => {
        const {
            dispatch,
            form,
        } = this.props;

        const filteredRegisterdFields = [];

        // Put the keys into the filteredFields and remove any duplicates.
        utils.each(fields, (field, key) => {
            const splittedKey = key.split('[');

            if (!~filteredRegisterdFields.indexOf(splittedKey[0])) {
                filteredRegisterdFields.push(splittedKey[0]);
            }
        });

        const valueKeys = Object.keys(values);

        /**
         * Loop through all values and check if they do not exist in the registered fields.
         * If so, then set the form value to null.
         */
        if (!valueKeys.length) {
            return;
        }

        utils.each(valueKeys, (value) => {
            if (!~filteredRegisterdFields.indexOf(value)) {
                dispatch(change(form, value, null));
            }
        });
    }

    handleSubmit = () => {
        const {
            dispatch,
            form,
            formInstance,
        } = this.props;

        if (utils.isEmpty(formInstance)) {
            return;
        }

        const {
            registeredFields,
            values,
        } = formInstance;

        // Filter all fields which are unregistered to be removed from the values.
        this.selectUnregisteredFieldValues(values, registeredFields);

        // In case of unregisterdValues we will wait for these actions to resolve.
        setTimeout(() => {
            dispatch(submit(form));
        }, 500);
    }

    handleClear = () => {
        const {
            dispatch,
            form,
            formInstance: {
                registeredFields,
                values,
            },
            updateFilters,
        } = this.props;

        this.setState((prevState) => {
            return {
                active: {},
                available: Object.assign({}, prevState.available, prevState.active),
            };
        }, () => {
            utils.each(registeredFields, (field, key) => {
                const splittedKey = key.split('[');

                if (values.hasOwnProperty(splittedKey[0])) {
                    dispatch(change(form, splittedKey[0], null));
                }
            });

            updateFilters();

            dispatch(submit(form));
        });

    }

    render() {
        const {
            category,
            filters,
            handleSubmit,
            resource,
            translate,
        } = this.props;

        const { active, available } = this.state;

        if (utils.isEmpty(filters)) {
            return null;
        }

        const hasFilters = !utils.isEmpty(active);

        return (
            <form onSubmit={ handleSubmit }>
                { utils.map(active, (element) => {
                    if (element === undefined) {
                        return;
                    }

                    const { component, matchTypes } = element;

                    if (!component) {
                        return;
                    }

                    const {
                        label,
                        placeholder,
                        source,
                    } = component.props;

                    return (
                        <Row
                            key={ `${ category }_active_${ source }` }
                        >
                            <Cell>
                                <RowTitle>
                                    { translate(label) }
                                </RowTitle>
                            </Cell>

                            <Cell>
                                <Field
                                    component={ MatchTypes }
                                    defaultValue={ matchTypes.default || matchTypes.values[0] }
                                    label={ label }
                                    name={ `${ source }[matchType]` }
                                    values={ matchTypes.values }
                                />
                            </Cell>

                            <Cell>
                                <Field
                                    { ...component.props }
                                    allowEmpty
                                    component={ component.type }
                                    floatingLabelFixed={ true }
                                    label={ null }
                                    name={ `${ source }[value]` }
                                    placeholder={ placeholder }
                                    resource={ resource }
                                />
                            </Cell>

                            <LastCell>
                                <IconButton
                                    onTouchTap={ () => {
                                        return this.removeFilter(source);
                                    } }
                                    style={ { transform: 'rotate(45deg)' } }
                                >
                                    <DeactivateIcon
                                        color={ theme.palette.secondary }
                                        hoverColor={ theme.palette.primary1Color }
                                    />
                                </IconButton>
                            </LastCell>
                        </Row>
                    );
                }) }

                <Row
                    key={ `${ category }_options` }
                >
                    <Cell>
                        { !utils.isEmpty(available) &&
                            <SelectField
                                fullWidth={ true }
                                hintText={ translate('filters.add') }
                                multiple={ true }
                                onChange={ (event, index, values) => {

                                    // The property Values will return an Array. We want to only pass the first value.
                                    const [
                                        value,
                                    ] = values;

                                    return this.addFilter(value);
                                } }
                            >
                                {
                                    utils.map(available, (availableFilter) => {
                                        const { component } = availableFilter;

                                        const { source } = component.props;

                                        return (
                                            <MenuItem
                                                key={ `available_${ source }` }
                                                primaryText={ translate(component.props.label) }
                                                value={ source }
                                            />
                                        );
                                    })
                                }
                            </SelectField>
                        }
                    </Cell>

                    <Cell></Cell>

                    <Cell></Cell>

                    <ActionCell
                        disabled={ !hasFilters }
                        onClick={ this.handleClear }
                        primaryText={ translate('filters.clear_all_filters') }
                    />

                    <ActionCell
                        disabled={ !hasFilters }
                        onClick={ this.handleSubmit }
                        primaryText={ translate('actions.search') }
                    />
                </Row>
            </form>
        );
    }
}

Advanced.propTypes = {
    category: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    filterValues: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    form: PropTypes.string.isRequired,
    formInstance: PropTypes.object,
    formValues: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        filterValues,
        form,
    } = props;

    const formInstance = state.form[form];

    return {
        initialValues: filterValues,
        formValues: getFormValues(form)(state),
        formInstance: formInstance,
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
        onSubmit: (values, action, props) => {
            let newValues = {};

            utils.each(values, function (value, key) {
                if (!value || utils.isEmpty(value.value)) {
                    return;
                }

                newValues[key] = value;
            });

            return props.updateFilters(newValues);
        },
    }),
    translate,
);

export default enhance(Advanced);



// WEBPACK FOOTER //
// ./src/components/list/Filters/modes/Advanced.js